var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C8.04717 2 6.41929 3.40041 6.06962 5.25209C5.99053 5.67091 5.65467 5.99357 5.23301 6.05581C3.21757 6.35332 2 7.69907 2 9C2 10.4602 3.5711 12 6 12C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14C2.90606 14 0 11.9581 0 9C0 6.60604 1.92718 4.79982 4.2717 4.21043C5.03327 1.77078 7.30894 0 10 0C12.6911 0 14.9667 1.77078 15.7283 4.21043C18.0728 4.79982 20 6.60604 20 9C20 11.9581 17.0939 14 14 14C13.4477 14 13 13.5523 13 13C13 12.4477 13.4477 12 14 12C16.4289 12 18 10.4602 18 9C18 7.69907 16.7824 6.35332 14.767 6.05581C14.3453 5.99357 14.0095 5.67091 13.9304 5.25209C13.5807 3.40041 11.9528 2 10 2ZM10 6C10.5523 6 11 6.44772 11 7V16.716L12.3217 15.496C12.7275 15.1214 13.3602 15.1467 13.7348 15.5525C14.1094 15.9583 14.0841 16.591 13.6783 16.9656L10.6783 19.7348C10.2952 20.0884 9.70478 20.0884 9.32172 19.7348L6.32172 16.9656C5.9159 16.591 5.89059 15.9583 6.2652 15.5525C6.6398 15.1467 7.27246 15.1214 7.67828 15.496L9 16.716V7C9 6.44772 9.44771 6 10 6Z",
    fill: "var(--grey-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a8205812304e759268de327671eb6f9b.svg";
export { ForwardRef as ReactComponent };